'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleSix = exports.TitleFive = exports.TitleFour = exports.TitleThree = exports.TitleOne = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./title.scss');

var _title = require('./title');

var _title2 = _interopRequireDefault(_title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TitleOne = function TitleOne(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(
    _title2.default,
    _extends({ weight: 'light' }, props),
    children
  );
};

exports.TitleOne = TitleOne;
TitleOne.propTypes = {
  children: _propTypes2.default.node
};

var TitleThree = function TitleThree(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ['children']);

  return _react2.default.createElement(
    _title2.default,
    _extends({ level: '3', weight: 'light' }, props),
    children
  );
};

exports.TitleThree = TitleThree;
TitleThree.propTypes = {
  children: _propTypes2.default.node
};

var TitleFour = function TitleFour(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ['children']);

  return _react2.default.createElement(
    _title2.default,
    _extends({ density: 'cozy', level: '4', weight: 'light' }, props),
    children
  );
};

exports.TitleFour = TitleFour;
TitleFour.propTypes = {
  children: _propTypes2.default.node
};

var TitleFive = function TitleFive(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ['children']);

  return _react2.default.createElement(
    _title2.default,
    _extends({ density: 'compact', level: '5', weight: 'bold' }, props),
    children
  );
};

exports.TitleFive = TitleFive;
TitleFive.propTypes = {
  children: _propTypes2.default.node
};

var TitleSix = function TitleSix(_ref5) {
  var children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ['children']);

  return _react2.default.createElement(
    _title2.default,
    _extends({ level: '6', density: 'compact', color: 'light' }, props),
    children
  );
};

exports.TitleSix = TitleSix;
TitleSix.propTypes = {
  children: _propTypes2.default.node
};